import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { NurseryService } from '../services/nursery.service.old';
import { GoogleMapsService } from '../services/google-maps.service';
import { ProductService } from '../services/product.service';
import { StatesService } from '../services/states.service.old';
import { phoneNumberValid, postalCodeValid, emailValid } from '../helpers/validations.helper';
import { transformPhoneNumberToReadable } from '../helpers/stringTransform.helper';
import { getProductionType } from '../helpers/stringTransform.helper';
import { getPackagingType } from '../helpers/stringTransform.helper';
import { getProductType } from '../helpers/stringTransform.helper';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {
  faChevronLeft,
  faExclamationCircle,
  faLeaf,
  faSpinner,
  faSyncAlt,
  faSignOutAlt,
  faTimes,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-user-menu',
  animations: [
    trigger(
      'sideMenuFade', [
        transition(':enter', [
          style({opacity: 0}),
          animate('250ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('0ms', style({opacity: 0}))
        ])
      ]
    ),
    trigger(
      'sideMenuFadeWithClose', [
        transition(':enter', [
          style({opacity: 0}),
          animate('250ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('250ms', style({opacity: 0}))
        ])
      ]
    ),
  ],
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  providers: [NurseryService, ProductService, GoogleMapsService, StatesService]
})
export class UserMenuComponent implements OnInit {
  // These will only update when the database is updated. Point of reference for when changes arent saved.
  userDataOG = {};
  userNurseriesOG = {};
  selectedNurseryOG = {};

  faChevronLeft = faChevronLeft;
  faExclamationCircle = faExclamationCircle;
  faLeaf = faLeaf;
  faSpinner = faSpinner;
  faSyncAlt = faSyncAlt;
  faSignOutAlt = faSignOutAlt;
  faTimes = faTimes;
  faUser = faUser;

  openMenu: boolean = false;
  menuToShow: string = "";
  editScreen: boolean = false;
  loadingSave: boolean = false;
  userData = { id: 0 };
  allNurseries = [];
  userNurseries = [];
  selectedNursery = {};
  nurseryProduct = [];
  nurseryPhotos = {
    photos: [],
    featuredId: null,
    selectedPhotoId: null,
  };
  newNursery = {};
  products = [];
  hintsOn = null;
  importMessage = {
    type: null,
    message: ''
  };
  managePhotos: boolean = false;
  testPhoto = '/assets/images/daisy-bg-image.jpg';
  loading = false;
  startDeleteClicked = false;
  // functions passed in
  @Input() updateUser: Function;
  @Input() logOutUser: Function;
  @Input() getNurseryProductWithId: Function;
  @Input() refreshNurseriesAndProduct: Function;
  @Input() productTypes: Array<any>;
  @Input() productionTypes: Array<any>;
  @Input() packagingTypes: Array<any>;
  constructor(private http: HttpClient,
    private nurseryService: NurseryService,
    private productService: ProductService,
    private googleMapsService: GoogleMapsService,
    private ref: ChangeDetectorRef,
    private statesService: StatesService
    ) { }

  ngOnInit() {
  }

  getStateGivenIdHtml(id) {
    return this.statesService.getStateFromIdOrDefault(id);
  }

  phoneNumberValidHtml(number) {
    return phoneNumberValid(number);
  }

  postalCodeValidHtml(number) {
    return postalCodeValid(number);
  }

  emailValidHtml(email) {
    return emailValid(email)
  }

  transformPhoneNumberToReadableHtml(number) {
    return transformPhoneNumberToReadable(number);
  }

  getProductionType(typeId) {
    return getProductionType(typeId, this.productionTypes);
  }

  getPackagingType(typeId) {
    return getPackagingType(typeId, this.packagingTypes);
  }

  getProductType(typeId) {
    return getProductType(typeId, this.productTypes);
  }

  logout() {
    this.logOutUser();
    this.closeUserMenu();
    this.ref.detectChanges();
  }

  openUserMenu() {
    this.openMenu = true;
    this.menuToShow = 'USER';
    this.editScreen = false;
    this.ref.detectChanges();
  }

  toggleUserMenu(userData, allNurseries: Array<any>) {
    if (this.openMenu) {
      this.openMenu = false;
      return;
    }
    console.log(userData, allNurseries);
    this.openMenu = !this.openMenu;
    this.menuToShow = 'USER';
    this.editScreen = false;
    this.setUpUserVariables(userData, allNurseries);
    this.ref.detectChanges();
  }

  closeUserMenu() {
    this.openMenu = false;
    this.menuToShow = '';
    this.editScreen = false;
    this.managePhotos = false;
    this.startDeleteClicked = false;
    this.ref.detectChanges();
  }

  changeMenu(newMenu:string) {
    this.menuToShow = newMenu;
    this.editScreen = false;
    this.managePhotos = false;
    this.startDeleteClicked = false;
    this.ref.detectChanges();
  }

  toggleEditOn() {
    this.editScreen = true;
    this.ref.detectChanges();
  }

  cancelEdits() {
    this.editScreen = false;
    // set variables back to default
    this.selectedNursery = JSON.parse(JSON.stringify(this.selectedNurseryOG));
    this.userData = JSON.parse(JSON.stringify(this.userDataOG));
    this.startDeleteClicked = false;
    this.ref.detectChanges();
  }
  saveNurseryEdits() {
    this.loadingSave = true;
    this.setNurseryActiveEligibilityAndUpdate(this.selectedNursery);
    this.ref.detectChanges();
  }
  setNurseryActiveEligibilityAndUpdate(nursery) {
    nursery.active = 0;
    if (nursery.name && nursery.contact_name && nursery.state_id && nursery.address && nursery.city && postalCodeValid(nursery.postal_code) && phoneNumberValid(nursery.phone) && emailValid(nursery.email)) {
      this.googleMapsService.getCoordsGivenAddress(nursery.address, nursery.city, nursery.state, (coords) => {
        if (coords) {
          nursery.lat_long = {
            lat: coords.lat(),
            lng: coords.lng(),
          }
        }
        console.log(nursery);
        nursery.active = 1;
        this.nurseryService.updateNursery(nursery).then((response) => {
          console.log(response, ' Updated');
          this.editScreen = false;
          this.loadingSave = false;
          this.userNurseriesOG = this.getNurseriesWithUserId(this.userData.id, this.allNurseries);
          this.selectedNurseryOG = response;
          this.refreshNurseriesAndProduct();
          this.ref.detectChanges();
        }, (response) => {
          this.loadingSave = false;
          console.log('Failed to save ', response);
          this.ref.detectChanges();
        });
      })
    } else {
      this.nurseryService.updateNursery(this.selectedNursery).then((response) => {
        console.log(response, ' Updated');
        this.editScreen = false;
        this.loadingSave = false;
        this.userNurseriesOG = this.getNurseriesWithUserId(this.userData.id, this.allNurseries);
        this.selectedNurseryOG = response;
        this.refreshNurseriesAndProduct();
        this.ref.detectChanges();
      }, (response) => {
        this.loadingSave = false;
        console.log('Failed to save ', response);
        this.ref.detectChanges();
      });
    }
  }
  saveUserEdits() {
    this.loadingSave = true;
    this.updateUser(this.userData).then((response) => {
      console.log(response, ' Updated');
      this.editScreen = false;
      this.loadingSave = false;
      this.userDataOG = response;
      this.refreshNurseriesAndProduct();
      this.ref.detectChanges();
    }, (response) => {
      this.loadingSave = true;
      console.log('Failed to save ', response);
      this.ref.detectChanges();
    });
    this.ref.detectChanges();
  }

  startDelete() {
    this.startDeleteClicked = true;
    this.ref.detectChanges();
  }

  finishDelete() {
    console.log('delete nursery');
    const selectedId = this.selectedNursery['id'];
    this.nurseryService.removeNursery(this.selectedNursery).then((response) => {
      console.log('deleted');
      this.openUserMenu();
      this.userNurseriesOG = this.getNurseriesWithUserId(this.userData.id, this.allNurseries);
      this.userNurseries = this.userNurseries.filter((nursery => nursery.id !== selectedId));
      this.refreshNurseriesAndProduct();
      this.ref.detectChanges();
    });
    this.ref.detectChanges();
  }

  managePhotosOn() {
    this.managePhotos = true;
    this.ref.detectChanges();
  }

  managePhotosOff() {
    this.managePhotos = false;
    this.ref.detectChanges();
  }

  toggleHelpHints(val) {
    this.hintsOn = val;
    this.ref.detectChanges();
  }

  clickNurseryToEdit(nurserySelected) {
    this.selectedNursery = nurserySelected;
    this.selectedNurseryOG = JSON.parse(JSON.stringify(nurserySelected));
    this.nurseryProduct = this.getNurseryProductWithId(nurserySelected.id, nurserySelected);
    this.getNurseryPhotos(nurserySelected.id);
    this.changeMenu('DETAILS');
    this.ref.detectChanges();
  }

  setUpUserVariables(user, allNurseries) {
    this.userData = user;
    this.userDataOG = JSON.parse(JSON.stringify(user));
    this.userNurseries = this.getNurseriesWithUserId(user.id, allNurseries);
    this.allNurseries = allNurseries;
    this.ref.detectChanges();
  }

  getNurseriesWithUserId(userId, allNurseries) {
    if (userId === 13) {
      return allNurseries;
    }
    return allNurseries.filter((nursery => nursery.user_id == userId)) || []; // filter
  }

  createNewNursery() {
    const newNurseryObj = {
      //req
      user_id: this.userData.id,
      state_id: 1,
      status_id: 1,
      //optional...
      name: '',
      contact_name: this.userData['name'] || '',
      address: '',
      city: '',
      postal_code: '',
      phone: '',
      email: this.userData['email'],
      website: '',
      active: 0,
    }
    // post new nursery
    this.nurseryService.postNewNursery(newNurseryObj).then((nurseryAdded) => {
      // success
      this.userNurseries.push(nurseryAdded);
      this.clickNurseryToEdit(nurseryAdded);
      this.toggleEditOn();
      this.refreshNurseriesAndProduct()
      this.ref.detectChanges();
    }, (error) => {
      // display some error...
      // on error
    });
    this.ref.detectChanges();
  }

  updateNursery(nurseryData) {
    this.nurseryService.updateNursery(nurseryData).then((nurseryUpdated) => {
      // success
      // this.userNurseries.push(nurseryAdded);
      // this.clickNurseryToEdit(nurseryAdded);
      this.ref.detectChanges();
    }, (error) => {
      // display some error...
      // on error
    });
    this.ref.detectChanges();
  }

  downloadCurrentInventory() {
    if (this.nurseryProduct.length > 0) {
      window.open(`https://wsnla-front.dev.everbearingservices.com/csvs/wsnla-import-template-${this.selectedNursery['id']}.xlsx`,'_blank');
    } else {
      window.open(`https://wsnla-front.dev.everbearingservices.com/csvs/WSNLA-VendorProductData.xlsx`,'_blank');
      // window.open(`https://wsnla-front.dev.everbearingservices.com/csvsWSNLA_VendorProductData_17Nov14_GCH (2).xlsx`,'_blank');
    }
    this.ref.detectChanges();
  }

  fileChange(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loading = true;
      let file: File = fileList[0];
      this.loading = true;
      this.nurseryService.uploadNurseryProduct(file, this.selectedNursery, this.userData)
      .then(data => this.handleUploadSuccess(data))
      .catch(data => this.handleError(data));
    }
    this.ref.detectChanges();
  }

  private handleUploadSuccess(msg) {
    // get new products!
    console.log('success', msg);
    this.refreshNurseriesAndProduct().then((values) => {
      console.log(values);
      this.nurseryProduct = this.getNurseryProductWithId(this.selectedNursery['id'], this.selectedNursery);
      this.importMessage.message = 'Successfully imported your products!';
      this.importMessage.type = "success";
      this.loading = false;
      // setTimeout(() => {
      //   console.log('5 seconds are over!');
      // }, 5000);
      setTimeout(() => this.resetImportMessage(), 3000);
      this.ref.detectChanges();
    });
    this.ref.detectChanges();
  }

  nurseryImageFileChange(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loading = true;
      let file: File = fileList[0];
      this.nurseryService.uploadNurseryPhoto(file, this.selectedNursery)
      .then(data => this.handleNurseryPhotoUploadSuccess(data))
      .catch(data => this.handleError(data));
    }
    this.ref.detectChanges();
  }

  featureNurseryPhoto(photoId) {
    let photoToUpdateIndex = -1;
    for (let i = 0; i < this.nurseryPhotos.photos.length; i++) {
      if (this.nurseryPhotos.photos[i].id === photoId) {
        this.nurseryPhotos.photos[i].featured = '1';
        photoToUpdateIndex = i;
        this.ref.detectChanges();
        break;
      }
    }
    if (photoToUpdateIndex > -1) {
      this.loading = true;
      this.nurseryService.updateNurseryPhoto(this.nurseryPhotos.photos[photoToUpdateIndex])
      .then(data => this.handleNurseryPhotoUploadSuccess(data))
      .catch(data => this.handleError(data));
    }
    this.ref.detectChanges();
  }

  removeNurseryPhoto(photoId) {
    let photoToUpdateIndex = -1;
    for (let i = 0; i < this.nurseryPhotos.photos.length; i++) {
      if (this.nurseryPhotos.photos[i].id === photoId) {
        photoToUpdateIndex = i;
        break;
      }
    }
    if (photoToUpdateIndex > -1) {
      this.loading = true;
      this.nurseryService.removeNurseryPhoto(this.nurseryPhotos.photos[photoToUpdateIndex])
      .then(data => this.handleNurseryPhotoUploadSuccess(data))
      .catch(data => this.handleError(data));
    }
    this.ref.detectChanges();
  }

  private handleNurseryPhotoUploadSuccess(msg) {
    // get new products!
    console.log('success', msg);
    this.getNurseryPhotos(this.selectedNursery['id']);
    this.loading = false;
    this.refreshNurseriesAndProduct();
    this.ref.detectChanges();
  }

  private handleError(error) {
    // message the user what happened
    console.log('fail', error);
    this.importMessage.message = 'There was an issue importing your products';
    this.importMessage.type = "error";
    this.loading = false;
    setTimeout(() => this.resetImportMessage(), 6000);
    this.ref.detectChanges();
  }

  resetImportMessage() {
    this.importMessage.type = null;
    this.importMessage.message = '';
    this.ref.detectChanges();
  }

  getNurseryPhotos(nurseryId) {
    this.nurseryService.getNurseryPhotosId(nurseryId || this.selectedNursery['id']).then((data) => {
      console.log(data);
      this.nurseryPhotos.photos = data;
      this.nurseryPhotos.featuredId = this.getFeaturedPhotoId(this.nurseryPhotos.photos);
      this.nurseryPhotos.selectedPhotoId = this.nurseryPhotos.photos[0] ? this.nurseryPhotos.photos[0].id : null;
      console.log(this.nurseryPhotos);
      this.ref.detectChanges();
    });
  }

  getFeaturedPhotoId(photoArray) {
    for (let i = 0; i < photoArray.length; i++) {
      if (photoArray[i].featured === 1)
        return photoArray[i].id;
    }
    this.ref.detectChanges();
    return null;
  }

  getPhotoSrcUrl(photoObj) {
    if (photoObj.photo) {
      if (photoObj.photo.includes('http')) return `https://wsnla-front.dev.everbearingservices.com/vendor-location-photos/DEFAULT.png`;
      return `https://wsnla-front.dev.everbearingservices.com/vendor-location-photos/${photoObj.photo}`;
    }
    return `https://wsnla-front.dev.everbearingservices.com/vendor-location-photos/DEFAULT.png`;
  }

  getPhotoSrcUrlWithId(id) {
    for (let i = 0; i < this.nurseryPhotos.photos.length; i++) {
      if (this.nurseryPhotos.photos[i].id == id)
        return this.getPhotoSrcUrl(this.nurseryPhotos.photos[i]);
    }
    return `https://wsnla-front.dev.everbearingservices.com/vendor-location-photos/DEFAULT.png`;
  }

  photoIsFeatured(photoId) {
    for (let i = 0; i < this.nurseryPhotos.photos.length; i++) {
      if (this.nurseryPhotos.photos[i].id == photoId)
        return this.nurseryPhotos.photos[i].featured == 1;
    }
    return false;
  }

  maxNurseryPhotos() {
    return this.nurseryPhotos.photos.length > 5;
  }

  openTab(url) {
    const win = window.open(url, '_blank');
    win.focus();
  }
}

